/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPaddleDiscountRequestDTO } from '../models/AddPaddleDiscountRequestDTO';
import type { MuseHubWebhookDTO } from '../models/MuseHubWebhookDTO';
import type { PaddleBaseWebhookV2DTOOfPaddleSubscriptionWebhookDataDTO } from '../models/PaddleBaseWebhookV2DTOOfPaddleSubscriptionWebhookDataDTO';
import type { PaddleBaseWebhookV2DTOOfPaddleTransactionWebhook } from '../models/PaddleBaseWebhookV2DTOOfPaddleTransactionWebhook';
import type { PaddleListPaymentsEntry } from '../models/PaddleListPaymentsEntry';
import type { PaddleSubscriptionPaymentReceiptEntry } from '../models/PaddleSubscriptionPaymentReceiptEntry';
import type { PaddleSubscriptionsListResult } from '../models/PaddleSubscriptionsListResult';
import type { RCNotification } from '../models/RCNotification';
import type { SubscriptionDTO } from '../models/SubscriptionDTO';
import type { UpgradeSubscriptionDTO } from '../models/UpgradeSubscriptionDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubscriptionsService {
  /**
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static subscriptionsPaddleBillingTransactionWebhook(
    requestBody: PaddleBaseWebhookV2DTOOfPaddleTransactionWebhook
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/paddleBillingTransactionNotification',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns string Notification has been processed
   * @throws ApiError
   */
  public static subscriptionsPaddleWebhookBilling(
    requestBody: PaddleBaseWebhookV2DTOOfPaddleSubscriptionWebhookDataDTO
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/paddleBillingNotification',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Could not verify paddle signature`,
        500: `An unhandled error occurred while processing the notification`,
      },
    });
  }

  /**
   * Handles subscriptions lifecycle notifications send by paddle.
   * @param formData
   * @returns binary Returns an Ok result.
   * @throws ApiError
   */
  public static subscriptionsPaddleWebhook(
    formData?: any
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/paddleNotification',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static subscriptionsRevenueCatWebhook(
    requestBody: RCNotification
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/revenueCatNotification',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns binary
   * @throws ApiError
   */
  public static subscriptionsHandleWebhook(
    requestBody: Array<MuseHubWebhookDTO>
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/musehubNotification',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns SubscriptionDTO List of active subscriptions
   * @throws ApiError
   */
  public static subscriptionsGetSubscriptions(): CancelablePromise<
    Array<SubscriptionDTO>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Subscriptions/activeSubscriptions',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * Fetch paginated results of subscriptions for Admins.
   * Pagination is applied based on the sorting of Ids.
   * @param lastId The last Id to be used to offset from
   * @param rowCount Amount of rows to get for this page
   * @returns PaddleSubscriptionsListResult List of Subscriptions
   * @throws ApiError
   */
  public static subscriptionsGetPaddleSubscriptions(
    lastId?: string,
    rowCount: number = 20
  ): CancelablePromise<PaddleSubscriptionsListResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Subscriptions',
      query: {
        lastId: lastId,
        rowCount: rowCount,
      },
    });
  }

  /**
   * @param id
   * @returns SubscriptionDTO
   * @throws ApiError
   */
  public static subscriptionsGetPaddleSubscription(
    id: string
  ): CancelablePromise<SubscriptionDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Subscriptions/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static subscriptionsDeletePaddleSubscription(
    id: string,
    requestBody: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Subscriptions/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Returned when no subscription with the given Id is found`,
      },
    });
  }

  /**
   * Upgrade a given subscription to another tier.
   * @param requestBody Body contains id of the subscription to upgrade and the ProductId to upgrade to.
   * @returns binary Returned when the upgrade process was successful
   * @throws ApiError
   */
  public static subscriptionsUpgradeSubscription(
    requestBody: UpgradeSubscriptionDTO
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/upgrade',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Returned when upgrade process failed`,
        409: `Upgrade case is not supported`,
      },
    });
  }

  /**
   * Add a discount to an existing paddle subscription.
   * @param requestBody Data specifying the subscription and discount that should be applied
   * @returns binary Returned when the modification has been added successfully.
   * @throws ApiError
   */
  public static subscriptionsAddDiscount(
    requestBody: AddPaddleDiscountRequestDTO
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Subscriptions/discount',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Provided values are invalid`,
        401: `User is not authorized`,
        404: `Subscription could not be found for the authenticated user`,
        422: `If discount cannot be applied to this subscription.`,
        500: `Failed to apply the discount`,
      },
    });
  }

  /**
   * @param subscriptionId
   * @returns PaddleListPaymentsEntry Returned when the receipts are found
   * @throws ApiError
   */
  public static subscriptionsGetPaddleReceipts(
    subscriptionId: string
  ): CancelablePromise<Array<PaddleListPaymentsEntry>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Subscriptions/paddleReceipts/{subscriptionId}',
      path: {
        subscriptionId: subscriptionId,
      },
      errors: {
        401: `User is not authorized`,
        404: `Subscription could not be found for the authenticated user`,
        500: `Internal error occurred while fetching receipts from paddle`,
      },
    });
  }

  /**
   * Fetch Receipt information for a given subscription.
   * Optionally can be filtered by startDate and EndDate to limit the results.
   * @param subscriptionId Payments for a specific subscription
   * @param startDate Payments starting after the date specified
   * @param endDate Payments ending the day before the date specified
   * @returns PaddleSubscriptionPaymentReceiptEntry Returns paddle receipt results list
   * @throws ApiError
   */
  public static subscriptionsGetAllPaddleReceipts(
    subscriptionId?: string,
    startDate?: string | null,
    endDate?: string | null
  ): CancelablePromise<Array<PaddleSubscriptionPaymentReceiptEntry>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Subscriptions/paddleReceipts/allReceiptsInRange',
      query: {
        subscriptionId: subscriptionId,
        startDate: startDate,
        endDate: endDate,
      },
      errors: {
        400: `Invalid value for subscription id`,
        404: `No paddle subscription found with given subscription id`,
      },
    });
  }
}
